{
  "title": "Kazino Keşbeki",
  "yourLevel": "SİZİN SƏVİYYƏNİZ",
  "completed": "TAMAMLANDI",
  "locked": "BAĞLI",
  "xpLabel": "Təcrübə",
  "xpRule": "Təcrübə xalının hesablanması: €1 mərc = {{xp}} təcrübə xalları",
  "cashback": "Keşbek {{pct}}%",
  "cashbackMax": "Keşbek {{lo}} - {{hi}}%",
  "daily": "Gündəlik",
  "everyDays": "Hər {{days}} gündə bir dəfə",
  "active": "Aktiv: AZN {{amount}}",
  "claim": "GÖTÜRMƏK",
  "howTitle": "Bu necə işləyir?",
  "how1": "Sevimli slot və oyunlarınızı oynayın",
  "how2": "Təcrübə qazanın və səviyyənizi artırın",
  "how3": "Keşbek və mükafatlar əldə edin",
  "lockedNote": "«{{name}}» səviyyəsinə çatmaq üçün daha çox təcrübə tələb olunur",
  "loginHint": "XP, keşbek və Götürmək üçün daxil olun",
  "login": "Daxil ol",
  "history": "Tarixçə",
  "historyEmpty": "Hələ qeyd yoxdur.",
  "claimTitle": "Keşbek götür",
  "claimAmount": "Məbləğ: {{amount}} AZN",
  "claimNote": "Birbaşa real balansa. Wagering: 0x.",
  "cancel": "Ləğv et",
  "confirm": "Təsdiq et",
  "congrats": "Təbriklər!",
  "newLevel": "Yeni VIP səviyyə: {{name}}",
  "continue": "Davam et",
  "infoBody": "Yalnız real pullu kazino mərcləri XP və keşbek yaradır. Bonus, idman və demo daxil deyil. 24 saat gözləmə və minimum 1 AZN.",
  "close": "Bağla",
  "maxNote": "VIP MAX — XP toplanması dayanıb. Kateqoriya üzrə dövriyyə keşbeki.",
  "level_1": "Mis",
  "level_2": "Bürünc",
  "level_3": "Gümüş",
  "level_4": "Qızıl",
  "level_5": "Yaqut",
  "level_6": "Safir",
  "level_7": "Almaz",
  "level_8": "VİP SƏVİYYƏ",
  "maintenance": "Texniki fasilə — götürmə müvəqqəti bağlıdır.",
  "xpRuleAzn": "Balans və keşbek AZN ilə göstərilir. XP hesablaması €1 mərc qaydası ilə eyni əmsaldadır (1 AZN mərc = {{xp}} XP).",
  "lockedShort": "BAĞLI",
  "rulesTitle": "QAYDALAR",
  "rulesIntro": "“VIP Cashback” Kazinosuna xoş gəlmisiniz! Sistem səviyyənizə, oyun növlərinə və mərc müntəzəmliyinə görə real pulun bir hissəsini geri almaq imkanı verir. Nə qədər aktiv oynasanız, bir o qədər tez-tez və daha çox keşbek əldə edirsiniz.",
  "rulesWhatTitle": "VIP Cashback nədir",
  "rulesWhat": "Keşbek — oyun aktivliyinə görə xərclənmiş vəsaitin bir hissəsinin geri qaytarılmasıdır. Dinamikdir və səviyyəniz yüksəldikcə dəyişir.",
  "rulesLevelsTitle": "Cashback səviyyələri",
  "rulesLevels1": "Sistemdə 8 səviyyə var. Növbəti səviyyəyə keçmək üçün təcrübə xalı toplamaq lazımdır.",
  "rulesLevels2": "Yeni səviyyə keşbek faizini və götürmə tezliyini artırır.",
  "rulesXpTitle": "Təcrübə xalının hesablanması",
  "rulesXpNote": "Hər səviyyədə €1 mərc = müvafiq XP. Saytda balans və keşbek AZN-dir; XP əmsalları eyni qaydada tətbiq olunur (1 AZN mərc = eyni XP).",
  "rulesCbTitle": "Cashback necə işləyir",
  "rulesCb1": "1–7 səviyyələrdə (Mis–Almaz) keşbek uduzulmuş mərclərə görə hesablanır.",
  "rulesCbFormula": "Keşbek = (Mərclərin cəmi − Qazanılan məbləğ) × keşbek %",
  "rulesCb2": "Dövr üzrə nəticə müsbətdirsə, keşbek 0 olur.",
  "rulesCb3": "VIP MAX-da keşbek hər real mərcə görə kateqoriya faizi ilə verilir: Slot 0.25%, Lotereya 0.20%, Canlı kazino 0.10%, Masa oyunları 0.05%.",
  "rulesImportantTitle": "Bilmək vacibdir",
  "rulesImportant1": "Bonus balanslı, idman və demo mərclər XP/keşbek yaratmır.",
  "rulesImportant2": "24 saat gözləmə və minimum 1 AZN götürmə qaydası qüvvədədir.",
  "rulesImportant3": "Keşbek birbaşa real balansa köçürülür (0x wagering).",
  "partners": "Tərəfdaşlar",
  "rulesXp1": "1-ci səviyyə “Mis”: Hər €1 mərc üçün oyunçu 100 təcrübə xalı alır",
  "rulesXp2": "2-ci səviyyə “Bürünc”: Hər €1 mərc üçün oyunçu 150 təcrübə xalı alır",
  "rulesXp3": "3-ci səviyyə “Gümüş”: Hər €1 mərc üçün oyunçu 200 təcrübə xalı alır",
  "rulesXp4": "4-ci səviyyə “Qızıl”: Hər €1 mərc üçün oyunçu 250 təcrübə xalı alır",
  "rulesXp5": "5-ci səviyyə “Yaqut”: Hər €1 mərc üçün oyunçu 300 təcrübə xalı alır",
  "rulesXp6": "6-ci səviyyə “Safir”: Hər €1 mərc üçün oyunçu 350 təcrübə xalı alır",
  "rulesXp7": "7-ci səviyyə “Almaz”: Hər €1 mərc üçün oyunçu 400 təcrübə xalı alır",
  "rulesXp8": "8-ci səviyyə “VIP MAX”: sonuncu səviyyə, təcrübə xalı verilmir"
}
